import type { GetPresetsParams } from '../types';

export const presetKeys = {
  all: ['presets'] as const,
  lists: () => [...presetKeys.all, 'list'] as const,
  list: (filters?: GetPresetsParams) => [...presetKeys.lists(), filters] as const,
  details: () => [...presetKeys.all, 'detail'] as const,
  detail: (id: string) => [...presetKeys.details(), id] as const,
  galleries: (id: string) => [...presetKeys.detail(id), 'galleries'] as const,
};
